/* ==========================================================
   SOLSTICE — BONUS OFFER v4.0
   Post-checkout popup. Prevents bonus digital products from
   being purchased without a protein in cart.
   v4.0: Plan Nutricional descontinuado. Se remueve del cart
   siempre (incluso con proteina). Popup solo ofrece Rutina.
   ========================================================== */

(function () {
  'use strict';

  // Bonus activo: se ofrece en popup y se agrega al cart
  const ACTIVE_BONUS = [
    { id: 9374410637452, handle: 'rutina-de-gym-solstice', title: 'Rutina de Gym Solstice' }
  ];

  // Descontinuado: se remueve del cart SIEMPRE, sin excepciones
  const DISCONTINUED = [
    { id: 9374406639756, handle: 'plan-nutricional-solstice', title: 'Plan Nutricional Solstice' }
  ];

  // Union: cualquier producto digital (para skips en deteccion de proteina)
  const DIGITAL_PRODUCTS = ACTIVE_BONUS.concat(DISCONTINUED);

  const PROTEIN_TAG = 'protein';

  const state = { cart: null, hasProtein: false };
  const tagCache = {};
  const imageCache = {};   // preloaded product images
  let syncing = false;
  let popupOpen = false;

  /* ── helpers ─────────────────────────────────────────── */

  const isProteinBuyer = () =>
    !!(window.SOLSTICE_CUSTOMER && window.SOLSTICE_CUSTOMER.is_protein_buyer === true);

  const fetchTags = async (handle) => {
    if (tagCache[handle]) return tagCache[handle];
    try {
      const p = await fetch(`/products/${handle}.js`).then(r => r.json());
      // Cache image while we have the response
      if (!imageCache[handle]) {
        imageCache[handle] = p.featured_image || (p.images && p.images[0]) || '';
      }
      return (tagCache[handle] = (p.tags || []).map(t => String(t).toLowerCase()));
    } catch { return []; }
  };

  // Fetch product images early so popup renders with them immediately
  const preloadImages = async () => {
    for (const dp of ACTIVE_BONUS) {
      if (imageCache[dp.handle]) continue;
      try {
        const p = await fetch(`/products/${dp.handle}.js`).then(r => r.json());
        imageCache[dp.handle] = p.featured_image || (p.images && p.images[0]) || '';
        if (!tagCache[dp.handle]) {
          tagCache[dp.handle] = (p.tags || []).map(t => String(t).toLowerCase());
        }
      } catch {}
    }
  };

  /* ── syncState (background, skips if already running) ── */

  const syncState = async () => {
    if (syncing) return;
    syncing = true;
    try {
      state.cart = await fetch('/cart.js').then(r => r.json());
      state.hasProtein = false;
      for (const item of state.cart.items) {
        if (DIGITAL_PRODUCTS.some(d => d.id === item.product_id)) continue;
        const tags = await fetchTags(item.handle);
        if (tags.includes(PROTEIN_TAG)) { state.hasProtein = true; break; }
      }
    } catch (e) { console.error('[Solstice]', e); }
    finally { syncing = false; }
  };

  /* ── forceSyncState (waits for any in-progress sync, then
       does its OWN fresh fetch — used in critical paths) ── */

  const forceSyncState = async () => {
    const deadline = Date.now() + 3000;
    while (syncing && Date.now() < deadline) {
      await new Promise(r => setTimeout(r, 50));
    }
    syncing = true;
    try {
      state.cart = await fetch('/cart.js').then(r => r.json());
      state.hasProtein = false;
      for (const item of state.cart.items) {
        if (DIGITAL_PRODUCTS.some(d => d.id === item.product_id)) continue;
        const tags = await fetchTags(item.handle);
        if (tags.includes(PROTEIN_TAG)) { state.hasProtein = true; break; }
      }
    } catch (e) { console.error('[Solstice]', e); }
    finally { syncing = false; }
  };

  /* ── autoCleanup ──────────────────────────────────────
     1. DISCONTINUED: se remueve siempre, sin condiciones.
     2. ACTIVE_BONUS: se remueve solo si no hay proteina.  */

  const autoCleanup = async () => {
    const items = state.cart?.items || [];
    const toRemove = [];

    // Descontinuados: fuera siempre
    for (const item of items) {
      if (DISCONTINUED.some(d => d.id === item.product_id)) toRemove.push(item);
    }

    // Bonus activos: fuera solo si no califica
    if (!state.hasProtein && !isProteinBuyer()) {
      for (const item of items) {
        if (ACTIVE_BONUS.some(d => d.id === item.product_id)) toRemove.push(item);
      }
    }

    if (!toRemove.length) return;
    for (const item of toRemove) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Solstice-Internal': '1' },
        body: JSON.stringify({ id: item.key, quantity: 0 })
      });
    }
    await syncState();
  };

  /* ── popup UI ─────────────────────────────────────────── */

  const POPUP_ID = 'slc-bonus-popup';

  const getPopupHTML = () => {
    const img = imageCache['rutina-de-gym-solstice'] || '';
    return `
    <div id="${POPUP_ID}" role="dialog" aria-modal="true" aria-label="Bonus Exclusivo Solstice"
      style="display:none;position:fixed;inset:0;z-index:99999;align-items:center;justify-content:center;padding:1rem;">
      <div class="slc-popup__backdrop" onclick="window.SolsticeBonus.closePopup()"
        style="position:absolute;inset:0;background:rgba(0,0,0,.55);backdrop-filter:blur(2px);"></div>
      <div class="slc-popup__card" style="position:relative;background:#fff;border-radius:16px;
        max-width:420px;width:100%;padding:2rem 1.5rem 1.5rem;box-shadow:0 24px 60px rgba(0,0,0,.18);">
        <button onclick="window.SolsticeBonus.closePopup()" aria-label="Cerrar"
          style="position:absolute;top:.75rem;right:.75rem;background:none;border:none;
          font-size:1.4rem;line-height:1;cursor:pointer;color:#888;padding:.25rem .5rem;">✕</button>

        <p style="font-size:.7rem;font-weight:700;letter-spacing:.12em;text-transform:uppercase;
          color:#888;margin:0 0 .35rem;">Solstice · Bonus Exclusivo</p>
        <h2 style="font-size:1.35rem;font-weight:800;color:#111;margin:0 0 .25rem;line-height:1.2;">
          ¡Llévate esto gratis!
        </h2>
        <p style="font-size:.85rem;color:#555;margin:0 0 1.25rem;line-height:1.4;">
          Por tu compra de proteína te regalamos este producto digital. Se agrega automáticamente.
        </p>

        <div style="display:flex;flex-direction:column;gap:.75rem;margin-bottom:1.5rem;">
          <div style="display:flex;align-items:center;gap:.75rem;background:#f7f7f7;
            border-radius:10px;padding:.75rem;">
            <div style="width:52px;height:52px;border-radius:8px;background:#e8e8e8;
              flex-shrink:0;overflow:hidden;">
              ${img
                ? `<img src="${img}" alt="Rutina de Gym" style="width:100%;height:100%;object-fit:cover;">`
                : `<div style="width:100%;height:100%;background:linear-gradient(135deg,#ddd,#bbb);"></div>`
              }
            </div>
            <div style="flex:1;min-width:0;">
              <p style="font-size:.85rem;font-weight:700;color:#111;margin:0;">Rutina de Gym</p>
              <p style="font-size:.75rem;color:#666;margin:.1rem 0 0;">Programa completo de fuerza y músculo</p>
            </div>
            <span style="font-size:.75rem;font-weight:800;color:#16a34a;background:#dcfce7;
              padding:.2rem .5rem;border-radius:999px;flex-shrink:0;">GRATIS</span>
          </div>
        </div>

        <button id="slc-bonus-cta"
          onclick="window.SolsticeBonus.addAllAndCheckout()"
          style="width:100%;padding:.9rem;background:#111;color:#fff;border:none;
          border-radius:10px;font-size:.95rem;font-weight:700;cursor:pointer;
          transition:opacity .15s;letter-spacing:.02em;">
          Agregar rutina y continuar al pago →
        </button>
        <button onclick="window.SolsticeBonus.closePopup()"
          style="width:100%;margin-top:.6rem;padding:.65rem;background:none;border:none;
          font-size:.8rem;color:#888;cursor:pointer;text-decoration:underline;">
          No gracias, solo quiero la proteína
        </button>
      </div>
    </div>
  `;
  };

  const injectPopup = () => {
    // Always remove old instance so images are fresh from cache
    const old = document.getElementById(POPUP_ID);
    if (old) old.remove();
    document.body.insertAdjacentHTML('beforeend', getPopupHTML());
  };

  const showPopup = () => new Promise(resolve => {
    injectPopup();
    const el = document.getElementById(POPUP_ID);
    if (!el) return resolve();
    el.style.display = 'flex';
    popupOpen = true;
    el._slcResolve = resolve;
  });

  const closePopup = () => {
    const el = document.getElementById(POPUP_ID);
    if (!el) return;
    el.style.display = 'none';
    popupOpen = false;
    if (typeof el._slcResolve === 'function') {
      el._slcResolve();
      el._slcResolve = null;
    }
  };

  const addAllAndCheckout = async () => {
    const ctaBtn = document.getElementById('slc-bonus-cta');
    if (ctaBtn) { ctaBtn.disabled = true; ctaBtn.textContent = 'Agregando...'; }
    try {
      const missing = ACTIVE_BONUS.filter(dp =>
        !state.cart?.items.some(i => i.product_id === dp.id)
      );
      for (const dp of missing) {
        const product = await fetch(`/products/${dp.handle}.js`).then(r => r.json());
        const variantId = product.variants[0]?.id;
        if (!variantId) continue;
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Solstice-Internal': '1' },
          body: JSON.stringify({ id: variantId, quantity: 1, properties: { _solstice_bonus: 'true' } })
        });
      }
    } catch (e) { console.error('[Solstice]', e); }
    // No navega aqui: closePopup resuelve la promesa y handleCheckout se encarga
    // de llevar al checkout. Un solo punto de salida para todos los caminos.
    closePopup();
  };

  /* ── checkout button interception ──────────────────────── */

  const handleCheckout = async (btn) => {
    if (btn) { btn.disabled = true; btn.style.opacity = '0.6'; }
    try {
      await forceSyncState();
      await autoCleanup();
      if (!state.hasProtein && !isProteinBuyer()) return;
      const allAdded = ACTIVE_BONUS.every(dp =>
        state.cart?.items.some(i => i.product_id === dp.id)
      );
      if (allAdded) return;
      if (btn) { btn.disabled = false; btn.style.opacity = ''; }
      // El popup solo ofrece. Se cierre como se cierre --aceptar, "No gracias",
      // la X o el backdrop-- el cliente ya pidio pagar, asi que continuamos.
      await showPopup();
    } catch (e) {
      console.error('[Solstice]', e);
    } finally {
      // hackCheckoutBtn le quito el submit nativo al boton, asi que esta es la
      // unica salida al checkout: tiene que correr pase lo que pase. Perder el
      // bonus por un error de red es preferible a dejar al cliente atorado.
      window.location.href = '/checkout';
    }
  };

  const hackCheckoutBtn = () => {
    document.querySelectorAll('button[name="checkout"]').forEach(btn => {
      if (btn._slcHacked) return;
      btn._slcHacked = true;
      btn.setAttribute('type', 'button');
      btn.addEventListener('click', () => handleCheckout(btn));
    });
  };

  /* ── fetch interceptor ─────────────────────────────────── */

  const hookFetch = () => {
    const orig = window.fetch;
    window.fetch = function (...args) {
      const url = String(args[0] || '');
      const opts = args[1] || {};
      const hdrs = opts.headers || {};
      const isInternal =
        hdrs['X-Solstice-Internal'] === '1' ||
        (hdrs instanceof Headers && hdrs.get('X-Solstice-Internal') === '1');
      const isMutation = /\/cart\/(add|change|update|clear)/.test(url);
      return orig.apply(this, args).then(res => {
        if (isMutation && !isInternal && res.ok) {
          setTimeout(async () => {
            await syncState();
            await autoCleanup();
          }, 300);
        }
        return res;
      });
    };
  };

  /* ── init ────────────────────────────────────────────── */

  const init = async () => {
    preloadImages(); // fire & forget — images ready before user clicks checkout
    await syncState();
    await autoCleanup();
    hookFetch();
    hackCheckoutBtn();
    new MutationObserver(hackCheckoutBtn).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('pageshow', (e) => {
      if (e.persisted) {
        forceSyncState().then(autoCleanup).then(hackCheckoutBtn);
      }
    });
    window.SolsticeBonus = { refresh: async () => { await syncState(); hackCheckoutBtn(); }, closePopup, addAllAndCheckout };
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();

})();